import React from "react";
import { AppRoutes } from "../../routes/AppRouter";
import Page from "../components/container/Page";
import LinkBulkImport from "../components/links/LinkBulkImport";
import LinkDialog from "../components/links/LinkDialog";
import UsefulLinks from "../components/links/UsefulLinks";
import SearchBox from "../components/search/SearchBox";
import { useLinks } from "../../state/api/links/useLinks";
import { useQueryValue } from "../../hooks/useSearch";
import { QUERY_KEY } from "../../types/query.types";

export default function UsefulLinksPage() {

  const { links, isRefetching } = useLinks();

  const { value } = useQueryValue(QUERY_KEY.LINK_Q);

  return (
    <Page title={AppRoutes.UsefulLinks.Label} subtitle={AppRoutes.UsefulLinks.Subtitle} actions={[
      <LinkBulkImport key="import" />,
      <LinkDialog key="add" />
    ]}
    >
      {(!!links?.length || value) && (
        <SearchBox loading={isRefetching} param={QUERY_KEY.LINK_Q} />
      )}
      <UsefulLinks />
    </Page>
  )
}